<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>产品管理</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form form-list">
                    <el-form-item>
                        <el-select v-model="searchData.product_type" filterable clearable placeholder="产品型号" :no-data-text="'暂无数据'">
                            <el-option :label="item" :value="item" v-for="item in productType" :key="item + '12345'"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <div class="button button2" @click="openAddDialog()" v-if="roleCheck('105-101-103-102')">
                    <i class="el-icon-plus"></i>
                    <span>新增</span>
                </div>
            </div>
            <el-table
                highlight-current-row
                :data="listData">
                <el-table-column prop="product_type" label="产品型号"></el-table-column>
                <el-table-column label="产品图片">
                    <template slot-scope="scope" >
                        <img class="banner_img" :src="scope.row.product_image_show" alt="">
                    </template>
                </el-table-column>
                <el-table-column prop="product_video" label="指导视频"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope" >
                        <div class="button text" @click="openUpdateDialog(scope.row)" v-if="roleCheck('105-101-103-102')">编辑</div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>

            <Gh-Dialog ref="productManage" size="big" :title="dialog.title" @dialogBack="updateConfirm">
                <template v-slot:content>
                    <el-form label-width="100px" :model="addData" ref="addProductRule" :rules="formRule">
                        <el-form-item label="产品型号" prop="product_type">
                            <el-input v-model="addData.product_type" maxLength="32" placeholder="请输入产品型号"></el-input>
                        </el-form-item>
                        <el-form-item label="产品图片" prop="product_image">
                            <el-upload
                                class="upload"
                                action=""
                                :http-request="uploadFile"
                                :show-file-list="false"
                                accept="image/*"
                                >
                                <img v-if="imageUrl" :src="imageUrl" class="banner_img">
                                <i v-else class="el-icon-plus banner_icon"></i>
                                <!-- <div slot="tip" class="el-upload__tip">（请使用21:9的图片）</div> -->
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="安装视频">
                            <el-input v-model="addData.product_video" placeholder="请输入安装视频地址"></el-input>
                        </el-form-item>
                    </el-form>
                </template>
            </Gh-Dialog>
        </div>
    </div>
    
</template>
<script>
export default({
    name: 'sn-manage',
    data() {
        return {
            searchData: {
                product_type: '',
                page: 1,
                page_size: 10
            },
            productType: [],
            listData: [],
            total: 0,
            dialog: {
                title: '',
                type: ''
            },
            imageUrl: '',
            addData: {
                product_type: '',
                product_image: '',
                product_video: ''
            },
            formRule: {
                product_type: [this.requiredRule('请输入产品型号')],
                product_image: [this.requiredRule('请选择图片')]
            }
        }
    },
    created() {
        this.getProductType();
        this.getList();
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        getProductType() {
            this.api.getProductType({}).then(data => {
                this.productType = data.data || [];
            })
        },  
        getList() {
            this.api.getProductInfo(this.searchData).then(data => {
                this.listData = data.data.list;
                this.total = data.data.total;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        openAddDialog() {
            this.dialog = {
                title: '新增产品',
                type: 'add'
            };
            this.addData = {
                product_type: '',
                product_image: '',
                product_video: ''
            };
            this.imageUrl = '';
            this.$refs.productManage.show = true;
        },
        openUpdateDialog(item) {
            this.dialog = {
                title: '编辑产品',
                type: 'update'
            };
            this.addData = {
                id: item.id,
                product_type: item.product_type,
                product_image: item.product_image,
                product_video: item.product_video
            };
            this.imageUrl = item.product_image_show;
            this.$refs.productManage.show = true;
        },  
        uploadFile(file) {
            /*
                上传alioss 上传展示的文件需要转成blob 创建链接展示
                上传alioss接口uploadAliOss，第一个参数为oss存储地址+文件名字，第二个参数为上传的文件
            */
            this.imageUrl = window.URL.createObjectURL(new Blob([file.file]));
            const timestamp = new Date().getTime();
            this.uploadAliOss(`op/product/${this.formDate(timestamp, 'YYYYMMDD')}/${timestamp+'_'+file.file.name}`, file.file).then(data => {
                this.addData.product_image = decodeURIComponent((data[0].split('aliyuncs.com/')[1]).split('?')[0]);
                this.$refs.addProductRule.validateField('product_image');
            }).catch(data => {
                this.imageUrl = item.product_image_show || '';
                console.log(data)
                this.$message.success('文件上传失败，请稍后重试!');
            });
        },
        updateConfirm() {
            this.$refs.addProductRule.validate(v => {
                if(v) {
                    this.api.uploadProductInfo(this.addData).then(data => {
                        if(data.code == 200) {
                            this.$message.success('操作成功！');
                            this.getProductType();
                            this.getList();
                            this.$refs.productManage.show = false;
                        }
                        
                    })
                }
            })
        }
    }
})
</script>
<style lang="less" scoped>
    //上传图片
    .banner_img{
        width: auto;
        height: 60px;
        margin: 0 auto;
    }
    .upload{
        .flexLayout(flex-start, flex-end);
        /deep/.el-upload{
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            .banner_img,.banner_icon{
                width: 100%;
                height: 90px;
            }
            .banner_icon{
                width: 210px;
            }
            .banner_icon{
                text-align: center;
                line-height: 90px;
                color: @colorBlue2;
                font-weight: 600;
            }
        }
        .el-upload__tip{
            color: #999;
        }
    }

</style>



// WEBPACK FOOTER //
// src/view/product/product-data/product-manage.vue